import { render } from "./ViewProduct.vue?vue&type=template&id=2c3d124a&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"

import "./ViewProduct.vue?vue&type=style&index=0&id=2c3d124a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3d124a"]])

export default __exports__